import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { RuntimesPage } from '@/features/admin/runtimes/runtime-pages';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Runtimes et versions (porting README #39). */
export const Route = createFileRoute('/$tenant/runtimes/')({ component: RuntimesRoute });

function RuntimesRoute() {
  const { tenant } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell tenantId={tenant} activeItem="runtimes" crumbs={[{ label: t('nav.items.runtimes') }]}>
      <RuntimesPage tenantId={tenant} />
    </ConsoleShell>
  );
}
